/**
 * Snowboard Addiction — AMP Back in Stock regional visibility
 * Source: layout/theme.liquid ~275–341 (Story v3.1 export, known-good)
 *
 * Shows/hides #BIS_trigger based on window.VariantInventory + selected variant.
 * Requires AMP app to inject #BIS_trigger.
 *
 * Load BEFORE sa-auto-variant-selector.js.
 * Note: updateBISButtonDisplay is scoped inside this IIFE in the source theme;
 * sa-auto-variant-selector.js calls it if typeof === 'function' (may no-op in Story).
 */
(function () {
  const inventory = window.VariantInventory || {};

  function getVariantId() {
    const selects = document.querySelectorAll('select[name="id"]');
    let select = null;
    for (const candidate of selects) {
      if (!candidate.closest('#overlays, #drawers')) {
        select = candidate;
        break;
      }
    }
    if (!select) select = selects[0] || null;
    const input = document.querySelector('input[name="id"]');

    const value = select?.value || input?.value;
    return value ? parseInt(value, 10) : null;
  }

  function updateBISButtonDisplay() {
    const bisButton = document.getElementById('BIS_trigger');
    const variantId = getVariantId();
    if (!bisButton || variantId === null) return;

    const stockLevel = inventory[variantId];
    setTimeout(() => {
      bisButton.style.setProperty(
        'display',
        stockLevel <= 0 ? 'block' : 'none',
        'important'
      );
    }, 100);
  }

  function watchInputChanges() {
    const input = document.querySelector('input[name="id"]');
    if (!input) return;

    let lastValue = input.value;

    setInterval(() => {
      if (input.value !== lastValue) {
        lastValue = input.value;
        updateBISButtonDisplay();
      }
    }, 200);
  }

  function waitForBISButton() {
    const observer = new MutationObserver((mutations, obs) => {
      const bisButton = document.getElementById('BIS_trigger');
      if (bisButton) {
        updateBISButtonDisplay();
        watchInputChanges();
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', waitForBISButton);
})();
